/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import $ from 'jquery'
import {ExcelExport, grid, gridColumn} from '@progress/kendo-react-excel-export'
import {message} from 'antd'
import cookie from 'react-cookies'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import Loader from '../loaders/loader'
import Pageing from '../Pagination/pageing'
import HeaderGrid from '../Pagination/HeaderGrid'
import Sort from '../Pagination/Sort'
import SearchableCombo from '../BaseComponent/searchableCombo'
import {productShop} from '../../lib/path'
import AutoComplete from '../BaseComponent/autocomplete'
class SuppliedPercent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      lengthbaskets: 0,
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      supplierOrder: [],
      providers: [],
      printInfo: [],
      selectedOption: [],
      excelData: [],
      fromDate: '',
      toDate: '',
      aggregation: {},
      buttonClicked: false,
      itemInfo: {},
      products: [],
      providerId: '',
      productId: '',
      pageNumber: 1,
      pageSize: 10,
      sortBy: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'supplyDate',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام محصول',
          value: 'productName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'واحد محصول',
          value: 'productUnitId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تامین کننده',
          value: 'providerName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد کل',
          value: 'allCount',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد تامین',
          value: 'notZeroCount',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد عدم تامین',
          value: 'zeroCount',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'درصد تامین',
          value: 'notZeroPercent',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'درصد عدم تامین',
          value: 'zeroPercent',
          sorted: false,
          direction: null,
          sortable: true
        }
      ],
      tablePageNumber: 1
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`report/retail/supplied/percent`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          if (!exportStatus) {
            $('.showBaseTable,.print').fadeIn()

            this.setState({
              tablePageNumber: this.state.pageNumber,
              tablePageSize: this.state.pageSize,
              supplierOrder: response.data.object.result,
              countAll: response.data.object.countAll,
              aggregation: response.data.object.aggregation,
              toPrintDate: this.state.fromDate == '' ? '-' : jMoment(this.state.fromDate).format('jYY/jMM/jDD'),
              fromPrintDate: this.state.toDate == '' ? '-' : jMoment(this.state.toDate).format('jYY/jMM/jDD'),
              buttonClicked: true,
              loading: false
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              aggregation: response.data.object.aggregation,
              loading: false
            })
          }
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            loading: false
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.export = exportStatus
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    // var productGrouping=document.getElementById('productGrouping').value;
    let providerId = this.state.providerId
    let productId = this.state.productId === '' || this.state.productId === null ? '' : this.state.productId.productId

    let allCountMin = this.convertDigit(document.getElementById('allCountMin').value.trim())
    let allCountMax = this.convertDigit(document.getElementById('allCountMax').value.trim())

    let zeroCountMin = this.convertDigit(document.getElementById('zeroCountMin').value.trim())
    let zeroCountMax = this.convertDigit(document.getElementById('zeroCountMax').value.trim())

    let notZeroCountMin = this.convertDigit(document.getElementById('notZeroCountMin').value.trim())
    let notZeroCountMax = this.convertDigit(document.getElementById('notZeroCountMax').value.trim())

    let zeroPercentMin = this.convertDigit(document.getElementById('zeroPercentMin').value.trim())
    let zeroPercentMax = this.convertDigit(document.getElementById('zeroPercentMax').value.trim())

    let notZeroPercentMin = this.convertDigit(document.getElementById('notZeroPercentMin').value.trim())
    let notZeroPercentMax = this.convertDigit(document.getElementById('notZeroPercentMax').value.trim())

    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }
    if (providerId !== '') {
      filter.providerId = providerId
    }
    if (productId !== '') {
      filter.productId = productId
    }
    if (allCountMin !== '') {
      filter.allCountMin = allCountMin
    }
    if (allCountMax !== '') {
      filter.allCountMax = allCountMax
    }
    if (zeroCountMin !== '') {
      filter.zeroCountMin = zeroCountMin
    }
    if (zeroCountMax !== '') {
      filter.zeroCountMax = zeroCountMax
    }
    if (notZeroCountMin !== '') {
      filter.notZeroCountMin = notZeroCountMin
    }
    if (notZeroCountMax !== '') {
      filter.notZeroCountMax = notZeroCountMax
    }
    if (zeroPercentMin !== '') {
      filter.zeroPercentMin = zeroPercentMin
    }
    if (zeroPercentMax !== '') {
      filter.zeroPercentMax = zeroPercentMax
    }
    if (notZeroPercentMin !== '') {
      filter.notZeroPercentMin = notZeroPercentMin
    }
    if (notZeroPercentMax !== '') {
      filter.notZeroPercentMax = notZeroPercentMax
    }
    if (minDate !== '') {
      filter.invoiceDateMin = minDate
    }
    if (maxDate !== '') {
      filter.invoiceDateMax = maxDate
    }

    filter.productGrouping = true

    return filter
  }

  componentDidMount() {
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {

    //     if (response.data.error == null) {

    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] = result[i].providerId +' - '+ result[i].title;
    //         }

    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });

    sessionStorage.removeItem('params')

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  filter() {
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    if (minDate === '' || maxDate === '') {
      message.error('هر دو تاریخ وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  getPrintInfo = () => {
    this.setState({
      loading: true
    })
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    let filter = this.createFilter()
    filter.export = true
    http
      .get(`report/retail/supplied/percent`, {
        params: filter
      })
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })

          let {excelReport} = this.state
          this._export.save(this.state.excelReport)
        }
        // else {
        //     $('.showBaseTable,.print').fadeOut();
        //     // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        // }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getValueProvider = (providerId) => {
    if (providerId === null) {
      this.setState({
        products: [],
        providerId: null
      })
    } else {
      this.setState({
        providerId
      })
      let id = providerId.providerId

      http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PRODUCT}?providerId=${id}`, {}).then((response) => {
        if (response.data.error === null) {
          var products = response.data.object
          for (let i = 0; i < products.length; i++) {
            products[i]['value'] = products[i].productId
            products[i]['label'] = products[i].articleId + ' - ' + products[i].productName
          }
          this.setState({
            products: response.data.object
          })
        } else {
          this.setState({
            products: []
          })
        }
      })
    }
  }

  getValueProduct = (productId) => {
    if (productId === null) {
      this.setState({
        productId: ''
      })
    } else {
      this.setState({
        productId
      })
    }
  }

  changeGrouping = (e) => {
    let target = e.target

    this.setState({
      grouping: target.options[target.selectedIndex].text
    })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state
    let reporterName = cookie.load('name')

    let printCol = [
      'ردیف',
      'نام محصول',
      'واحد محصول',
      'تامین کننده',
      'تعداد کل',
      'تعداد تامین',
      'تعداد عدم تامین',
      'درصد تامین',
      'درصد عدم تامین'
    ]

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="printSection">
          <table className="printTable printReportTable landscapeTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش میزان دقت تامین کالا"
              reporter={reporterName}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              headerColSpan={9}
              rightColSpan={4}
              centerColSpan={2}
              leftColSpan={3}
              centerSection={''}
              rightSection={'تاریخ فاکتور از : ' + this.state.toPrintDate + ' تا ' + this.state.fromPrintDate}
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((items, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{items.item.productName}</td>
                  <td>{items.item.productUnitTitle}</td>
                  <td>{items.item.providerName}</td>
                  <td>{items.allCount}</td>
                  <td>{items.notZeroCount}</td>
                  <td>{items.zeroCount}</td>
                  <td>{items.notZeroPercent}</td>
                  <td>{items.zeroPercent}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش میزان دقت تامین کالا.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'productName'}
                field={'item.productName'}
                title={'نام محصول'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'productUnitTitle'}
                field={'item.productUnitTitle'}
                title={'واحد محصول'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'providerName'}
                field={'item.providerName'}
                title={'تامین کننده'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'allCount'}
                field={'allCount'}
                title={'تعداد کل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'notZeroCount'}
                field={'notZeroCount'}
                title={'تعداد تامین'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'zeroCount'}
                field={'zeroCount'}
                title={'تعداد عدم تامین'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'notZeroPercent'}
                field={'notZeroPercent'}
                title={'درصد تامین'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'zeroPercent'}
                field={'zeroPercent'}
                title={'درصد عدم تامین'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>میزان دقت تامین کالا</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ سفارش از"
                  toLabel="تاریخ سفارش تا"
                  defaulValue={true}
                  force
                  fromId="from"
                  toId="to"
                />

                <div className="formComponent">
                  <label>تعداد کل از :</label>
                  <input type="text" className="form-control" id="allCountMin" name="allCountMin" />
                </div>
                <div className="formComponent">
                  <label>تعداد کل تا :</label>
                  <input type="text" className="form-control" id="allCountMax" name="allCountMax" />
                </div>

                <div className="formComponent">
                  <label>تعداد تامین از :</label>
                  <input type="number" className="form-control" id="notZeroCountMin" name="notZeroCountMin" />
                </div>
                <div className="formComponent">
                  <label>تعداد تامین تا :</label>
                  <input type="number" className="form-control" id="notZeroCountMax" name="notZeroCountMax" />
                </div>

                <div className="formComponent">
                  <label>تعداد عدم تامین از :</label>
                  <input type="number" className="form-control" id="zeroCountMin" name="zeroCountMin" />
                </div>
                <div className="formComponent">
                  <label>تعداد عدم تامین تا :</label>
                  <input type="number" className="form-control" id="zeroCountMax" name="zeroCountMax" />
                </div>

                <div className="formComponent">
                  <label>درصد تامین از :</label>
                  <input type="number" className="form-control" id="notZeroPercentMin" name="notZeroPercentMin" />
                </div>
                <div className="formComponent">
                  <label>درصد تامین تا :</label>
                  <input type="number" className="form-control" id="notZeroPercentMax" name="notZeroPercentMax" />
                </div>

                <div className="formComponent">
                  <label>درصد عدم تامین از :</label>
                  <input type="number" className="form-control" id="zeroPercentMin" name="zeroPercentMin" />
                </div>
                <div className="formComponent">
                  <label>درصد عدم تامین تا :</label>
                  <input type="number" className="form-control" id="zeroPercentMax" name="zeroPercentMax" />
                </div>

                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                  {/* <SearchableCombo
                                        options={this.state.providers}
                                        getValueCombo={this.getValueProvider}
                                        lableText='تامین کننده'
                                        placeholder='------'
                                        isClearable={true}
                                        isMulti={false}
                                        className='font-weight-bold'

                                    /> */}
                </div>
                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.products}
                    getValueCombo={this.getValueProduct}
                    lableText="کالا"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    className="font-weight-bold"
                  />
                </div>

                {/*<div className='formComponent'>*/}
                {/*    <label>بر مبنای </label>*/}
                {/*    <select className='form-control' onChange={this.changeGrouping} id='productGrouping'>*/}
                {/*        <option value={true}>محصول</option>*/}
                {/*        <option value={false}>تامین کننده</option>*/}
                {/*    </select>*/}
                {/*</div>*/}
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable" ref={(node) => (this.printTable = node)}>
                <tbody>
                  <Sort data={this.state.sortData} getSort={this.getSort} />

                  {this.state.supplierOrder.map((items, index) => (
                    <tr key={index}>
                      <td>{(this.state.tablePageNumber - 1) * this.state.tablePageSize + index + 1}</td>
                      <td>
                        <a
                          target="_blank"
                          href={productShop({
                            articleId: items.item.articleId
                          })}
                        >
                          {items.item.productName}
                        </a>
                      </td>
                      <td>{items.item.productUnitTitle}</td>
                      <td>{items.item.providerName}</td>
                      <td>{items.allCount}</td>
                      <td>{items.notZeroCount}</td>
                      <td>{items.zeroCount}</td>
                      <td>{items.notZeroPercent}</td>
                      <td>{items.zeroPercent}</td>
                    </tr>
                  ))}
                  <tr />
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SuppliedPercent
